import React, { Fragment } from 'react'
import { observer } from 'mobx-react-lite'
import { Divider } from 'shared/ui'
import { useRcsCreateContext } from 'pages/settings/pages/rcs/context/rcsCreateContext'
import { BrandContactSectionField } from './BrandContactSectionField'

export const BrandContactSection: React.FC = observer(() => {
  const {
    profileStore: {
      addNumber,
      canAddNumber,
      numbers,
      removeNumber,
      hasNumbers,
      setValue,
      setLabel,
      addEmail,
      canAddEmail,
      emails,
      removeEmail,
      hasEmails,
      addWebsite,
      canAddWebsite,
      websites,
      removeWebsite,
      hasWebsites,
      canDeleteNumberOrEmail,
    },
    loading,
  } = useRcsCreateContext()

  return (
    <Fragment>
      <BrandContactSectionField
        values={numbers}
        hasValues={hasNumbers}
        canAdd={canAddNumber}
        add={addNumber}
        remove={removeNumber}
        setLabel={setLabel}
        loading={loading}
        textLabel='Phone'
        textDescription='Up to 3 phone numbers allowed'
        textHeaderValue='Phone number'
        canDelete={canDeleteNumberOrEmail}
        addButtonTooltipProps={{
          label: !canAddNumber ? 'You can add up to 3 phone numbers' : '',
          placement: 'top',
        }}
      />
      <Divider sx={{ borderColor: 'var(--black-10)' }} />
      <BrandContactSectionField
        values={emails}
        hasValues={hasEmails}
        canAdd={canAddEmail}
        add={addEmail}
        remove={removeEmail}
        setLabel={setLabel}
        setValue={setValue}
        loading={loading}
        textLabel='Email'
        textDescription='Up to 3 email addresses allowed'
        textHeaderValue='Email address'
        valuePlaceholder='Enter email address'
        canDelete={canDeleteNumberOrEmail}
        addButtonTooltipProps={{
          label: !canAddEmail ? 'You can add up to 3 email addresses' : '',
          placement: 'top',
        }}
      />
      <Divider sx={{ borderColor: 'var(--black-10)' }} />
      <BrandContactSectionField
        values={websites}
        hasValues={hasWebsites}
        canAdd={canAddWebsite}
        add={addWebsite}
        remove={removeWebsite}
        setLabel={setLabel}
        setValue={setValue}
        loading={loading}
        textLabel='Website'
        textDescription='Up to 3 URLs allowed'
        textHeaderValue='URL'
        valuePlaceholder='https://'
        addButtonTooltipProps={{
          label: !canAddWebsite ? 'You can add up to 3 websites' : '',
          placement: 'top',
        }}
      />
    </Fragment>
  )
})
